// Function to generate image paths for a category
export const generateImagePaths = (gigId, category, basePath = '/gallerypage') => {
  // For now, we'll use a fixed number based on the category and gig
  // In a real implementation, you would scan the directory for actual files
  const lengths = {
    1: {
      originals: 4,
      bw: 4
    },
    2: {
      originals: 7,
      bw: 8
    },
    3: {
      originals: 16,
      bw: 22
    },
    4: {
      originals: 10,
      bw: 14
    },
    5: {
      originals: 6,
      bw: 9
    },
    6: {
      originals: 4,
      bw: 12
    }
  };

  // Always use lowercase .jpg extension
  const ext = 'jpg';
  const length = lengths[gigId]?.[category] || 0;
  return Array.from({length}, (_, i) => `${basePath}/${gigId}/${category}/${i + 1}.${ext}`);
}; 